import React, { useEffect, useRef, useState } from 'react'
import './manage-users.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartPie, faDownload, faFilter, faMagnifyingGlass, faPen, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { format } from 'date-fns';
import { switchUserButtons } from './admin-users.component';
import { Link, useNavigate } from 'react-router-dom';
import UserFilterModal from './user-filter-modal.component';
import CsvDownload from 'react-json-to-csv';

const ManageUsers = ({ 
    users, 
    sortId,
    nfeRegs,
    regs
}) => {

    const [ filteredUsers, setFilteredUsers ] = useState([]);
    const [ showFilterModal, setShowFilterModal ] = useState(false);
    const [ downloadData, setDownloadData ] = useState(null);
    const [ filter, setFilter ] = useState({});
    const [ pageTitle, setPageTitle ] = useState(null);
    const [ regsByUser, setRegsByUser ] = useState({});
    const [ evaluatorRegs, setEvaluatorRegs ] = useState({});
    const [ headers, setHeaders ] = useState([
        'cst_key',
        'fName',
        'lName',
        'email',
        'iein',
        'org',
        'city',
        'state',
        'recno',
        'participant',
        'evaluator',
        'admin',
        'status',
        'ts',
        'ts_joined',
    ])
    const navigate = useNavigate();
    const filterRef = useRef();

    useEffect(() => {
        switchUserButtons('users')
    }, [])

    useEffect(() => {
        if (!downloadData) return;
        document.getElementById('download-btn').click();
    }, [downloadData])

    useEffect(() => {
        if (!regs) return;
        let obj = {}
        for (let mc of Object.values(regs)) {
            let userArr = []
            for (let cst_key of Object.keys(mc.roles)) {
                const role = mc.roles[cst_key];
                if (role.includes('eval')) {
                    userArr.push(cst_key);
                }
            }
            obj[mc.mc_key] = userArr;
        }
        setEvaluatorRegs({...obj});
    }, [regs])

    useEffect(() => {
        if (!nfeRegs) return;
        let userRegs = {};
        for (let mc_key of Object.keys(nfeRegs)) {
            const mcRegs = nfeRegs[mc_key];
            for (let cst_key of Object.keys(mcRegs)) {
                if (userRegs[cst_key]) {
                    userRegs[cst_key].push(mc_key);
                } else {
                    userRegs[cst_key] = [mc_key];
                }
            }
        }
        setRegsByUser(userRegs);
    }, [nfeRegs])

    useEffect(() => {
        if (!users || !sortId) {return;}
        displayUsers();
        
    }, [users, sortId, filter])

    function displayUsers() {
        let filter1 = Object.values(users)
        .filter(u => {
            let match = true;
            for (let f of Object.values(filter)) {
                if (f.condition === 'equals') {
                    if (u[f.key] !== f.value) {
                        match = false;
                    }
                } else if (f.condition === 'greaterThan') {
                    if (u[f.key] < f.value) {
                        match = false;
                    }
                } else if (f.condition === 'lessThan') {
                    if (u[f.key] > f.value) {
                        match = false;
                    }
                }
            }
            return match;
        })
        if (sortId === 'part') {
            const filtered = filter1
            .filter(u => 
                u.permiss_part && 
                u.status === 'active'
            )
            setFilteredUsers(filtered);    
            switchUserButtons('participants');
            setPageTitle('Manage Micro-Credential Participants');
        }
        else if (sortId === 'eval') {
            const filtered = filter1
            .filter(u => 
                u.permiss_eval &&
                u.status === 'active'
            )
            setFilteredUsers(filtered);    
            switchUserButtons('evaluators');
            setPageTitle('Manage Evaluators');
        } 
        else if (sortId === 'admin') {
            const filtered = filter1
            .filter(u => 
                u.permiss_admin && 
                u.status === 'active'
            )
            setFilteredUsers(filtered);    
            switchUserButtons('administrators');
            setPageTitle('Manage Platform Administrators');
        } 
        else if (sortId === 'inactive') {
            const filtered = filter1
            .filter(u => u.status !== 'active')
            setFilteredUsers(filtered);    
            switchUserButtons('inactive');
            setPageTitle('Manage Inactive Users');
        }
        else {
            const filtered = filter1
            .filter(u => u.status === 'active')
            setFilteredUsers(filtered);   
            switchUserButtons('users');
            setPageTitle('Manage All Users')
        }
    }

    function searchPeople(str) {
        const test = str.toLowerCase();
        setFilteredUsers(Object.values(users).filter(u => 
            u.fName.toLowerCase().includes(test) || 
            u.lName.toLowerCase().includes(test) || 
            u.email.toLowerCase().includes(test)
        ))
    }

    function getUserDataForDownload() {
        console.log('getting download')
        let csvData = [];
        for (let u of filteredUsers.sort((a,b) => a.lName > b.lName ? 1 : -1)) {
            let obj = {};
            headers.map(key => {
                if (key === 'participant' && u.permiss_part) {
                    obj[key] = true;
                } else if (key === 'evaluator' && u.permiss_eval) {
                    obj[key] = true;
                } else if (key === 'admin' && u.permiss_admin) {
                    obj[key] = true;
                } else {
                    obj[key] = u[key];
                }
            })
            csvData.push(obj);
        }
        setDownloadData(csvData);
    }

    return (
        <div className='manage-users'>
            <div className='section-title with-icon'>
                {pageTitle}
                <Link to='/admin/createuser'>
                    <button 
                        className='g-button'
                        title='Create New User' >
                        Add New User
                        <FontAwesomeIcon icon={faPlusCircle} />
                    </button>
                </Link>
                {/* <FontAwesomeIcon className='clickable icon' title='Create New User' icon={faPlusCircle} onClick={() => navigate('/admin/createuser')} /> */}
            </div>
            <div className="g-space-1"></div>
            <div className='search-div'>
                <div className='search-bar'>
                    <div className='field small'>
                        <input text='text' onChange={(e) => searchPeople(e.target.value)} />
                    </div>
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                </div>
                <button 
                    className='g-button small-btn'
                    title='Filter User List'
                    onClick={() => setShowFilterModal(true)} >
                    <FontAwesomeIcon 
                        icon={faFilter} 
                        className={Object.values(filter).length > 0 ? 'filter-full' : 'filter-empty'} />
                </button>
                <button 
                    className='g-button small-btn'
                    title='Download This Data'
                    onClick={() => getUserDataForDownload()}>
                    <FontAwesomeIcon 
                        icon={faDownload} 
                        className='' />
                </button>
                <CsvDownload
                    className='hide'
                    id='download-btn'
                    data={downloadData}
                    headers={headers}
                    delimiter=',' 
                    filename={`mc_user_data_${format(new Date(), "P").replace("/", "")}.csv`} />
            </div>
            <div className="g-space-1"></div>
            <div className='meta'>
                User Count: {filteredUsers.length}
            </div>
            {
                (users) &&
                <table className='g-table'>
                    <thead>
                        <tr>
                            <td>Name</td>
                            <td>Email</td>
                            <td>State</td>
                            <td>Last Activity</td>
                            <td>Enrolled</td>
                            <td>Evaluating</td>
                            <td>Actions</td>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        filteredUsers.sort((a, b) => (a.lName.toLowerCase() > b.lName.toLowerCase()) ? 1 : (a.lName.toLowerCase() === b.lName.toLowerCase()) ? ((a.fName.toLowerCase() > b.fName.toLowerCase()) ? 1 : -1) : -1 )
                        .map((user, index) => (
                            (user.fName) && 
                            <tr key={index}>
                                <td>{user.fName ? `${user.lName}, ${user.fName}` : ''}</td>
                                <td>{user.email ?? ''}</td>
                                <td>{user.state}</td>
                                <td>{user.ts ? format(new Date(Number(user.ts)), "P") : 'Pending'}</td>
                                <td>{regsByUser[user.cst_key] ? regsByUser[user.cst_key].length : 0}</td>
                                <td>{Object.values(evaluatorRegs).filter(e => e.includes(user.cst_key)).length}</td>
                                <td className='actions'>
                                    <Link to={`/admin/userdata/${user.cst_key}`}>
                                        <button className='g-button small-btn' title='View User Data'><FontAwesomeIcon icon={faChartPie}  /></button>
                                    </Link>
                                    <Link to={`/admin/edituser/${user.cst_key}`}>
                                        <button className='g-button small-btn' title='Edit User'><FontAwesomeIcon icon={faPen} /></button>
                                    </Link>
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            }
            <UserFilterModal
                show={showFilterModal}
                cancel={() => setShowFilterModal(false)} 
                filter={filter}
                setFilter={setFilter} />
        </div>
    )
}

export default ManageUsers